import { handleFetchErrors, handleFailedToFetch } from "../helpers";
import { ROOT_URL } from "./config";
import { LOGIN_SUCCESS, LOGING_FAILURE } from "constant/auth";

export function loginSuccess(info) {
	////console.log(info);
	return {
		type: LOGIN_SUCCESS,
		info,
	};
}

export function loginFailure(error) {
	return {
		type: LOGING_FAILURE,
		error,
	};
}
export function authenticationCheck() {
	return (dispatch) => {
		// API REQUEST
		return fetch(`${ROOT_URL}/authentication`, {
			credentials: "include",
		})
			.then(handleFetchErrors, handleFailedToFetch)
			.then((response) => response.json())
			.then((response) => {
				// SUCCEED
				dispatch({
					type: LOGIN_SUCCESS,
					plyload: response,
				});
			})
			.catch((error) => {
				// FAILED
				dispatch(loginFailure(error));
			});
	};
}
